export type StatusEnum = 'public' | 'draft' | 'archive';
export const StatusEnum = {
  Public: 'public' as StatusEnum,
  Draft: 'draft' as StatusEnum,
  Archive: 'archive' as StatusEnum,
};

export type PublishTypeEnum = 'publish' | 'inactive';
export const PublishTypeEnum = {
  Publish: 'publish' as PublishTypeEnum,
  Inactive: 'inactive' as PublishTypeEnum,
}

export type LanguageEnum = 'th' | 'en';
export const LanguageEnum = {
  Th: 'th' as LanguageEnum,
  En: 'en' as LanguageEnum,
};

export type UpperCaseLanguageEnum = 'TH' | 'EN';
export const UpperCaseLanguageEnum = {
  TH: 'TH' as UpperCaseLanguageEnum,
  EN: 'EN' as UpperCaseLanguageEnum,
};

export type TargetEnum = '_self' | '_blank';
export const TargetEnum = {
  Self: '_self' as TargetEnum,
  Blank: '_blank' as TargetEnum,
};

export type ActiveEnum = 'active' | 'inactive';
export const ActiveEnum = {
  Active: 'active' as ActiveEnum,
  Inactive: 'inactive' as ActiveEnum,
};



